import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import GreenChunk from '@/components/ReactIntlChunks/GreenChunk';
import SortSectionSkeleton from '@/components/Search/components/SortSectionSkeleton/SortSectionSkeleton';
import useFormattedSortMessages from '@/components/Search/hooks/useFormattedSortMessages';
import Select from '@/Molecules/Select/Select';

import messages from './messages';

import useStyles from './styles';

type Props = {
  searchResultsTotalCount: number;
  isLoading: boolean;
  isMobile: boolean;
  criteria: number;
  onSortCriteriaChange: (_value: number) => void;
};

const SortSection: FC<Props> = ({
  searchResultsTotalCount = 0,
  isLoading,
  isMobile = false,
  criteria,
  onSortCriteriaChange,
}) => {
  const { classes } = useStyles();
  const { formattedSortCriteria } = useFormattedSortMessages();

  if (isLoading) return <SortSectionSkeleton />;

  return (
    <div className={classes.root}>
      <Typography>
        <FormattedMessage
          {...messages.searchTitle}
          values={{
            number: searchResultsTotalCount,
            green: GreenChunk,
            isMobile,
          }}
        />
      </Typography>
      <div className={classes.sortByCtn}>
        <Typography>
          <FormattedMessage {...messages.sortBy} />
        </Typography>
        <Select
          className={classes.sortCriteria}
          value={criteria}
          selectors={formattedSortCriteria}
          onChange={onSortCriteriaChange}
        />
      </div>
    </div>
  );
};

export default SortSection;
